import React from 'react';
import './EventDetails.less';
import { inject, observer } from 'mobx-react';
import { Row, Col, Tabs } from 'sd-ui-components';
import EventVideo from './EventVideo';
import EventContent from './EventContent';
import EventMap from './EventMap';
import { logUserEvent } from '../../apis/GoogleAnalyticsApi';

const TabPane = Tabs.TabPane;

@inject('EventsStore')
@observer
export default class EventTabs extends React.Component {
  onTabChanged = async activeTabKey => {
    const { EventsStore } = this.props;

    EventsStore.setActiveTab(activeTabKey);

    this.logTabEvent(activeTabKey);

    this.handleVideoOnTabChange(activeTabKey);

    this.props.onTabChanged && this.props.onTabChanged(activeTabKey);
  };

  handleVideoOnTabChange(activeTabKey) {
    const { EventsStore } = this.props;

    if (activeTabKey !== EventsStore.tabKeys.video) {
      EventsStore.pauseActiveVideo();
    }
  }

  logTabEvent(activeTabKey) {
    const { EventsStore } = this.props;

    const action = 'Navigated to event detail tab';
    let label;

    if (activeTabKey === EventsStore.tabKeys.details) {
      label = 'Details';
    } else if (activeTabKey === EventsStore.tabKeys.video) {
      label = 'Video';
    } else {
      label = 'Map';
    }

    logUserEvent(action, label);
  }

  render() {
    const { EventsStore } = this.props;
    const event = this.props.event;

    return (
      <React.Fragment>
        <Tabs
          ref={tabsRef => (this.tabsRef = tabsRef)}
          type="line"
          onChange={activeKey => this.onTabChanged(activeKey)}
          defaultActiveKey={EventsStore.tabKeys.details}
          activeKey={EventsStore.activeTab}
        >
          <TabPane
            tab="Details"
            key={EventsStore.tabKeys.details}
            data-automation-id="sd-ui-driver-eventdetails-tab-details"
            className="event-details-tab-details"
          >
            <EventContent event={event} />
          </TabPane>
          {event.safetyEventVideoUrl && (
            <TabPane
              tab="Video"
              key={EventsStore.tabKeys.video}
              data-automation-id="sd-ui-driver-eventdetails-tab-video"
            >
              <Row>
                <Col span={24}>
                  <EventVideo
                    onReady={(pauseFn, playFn) => {
                      EventsStore.activeVideoControls.pause = pauseFn;
                      EventsStore.activeVideoControls.play = playFn;
                    }}
                    videoUrl={event.safetyEventVideoUrl}
                  />
                </Col>
              </Row>
            </TabPane>
          )}

          <TabPane
            tab="Map"
            key={EventsStore.tabKeys.maps}
            data-automation-id="sd-ui-driver-eventdetails-tab-map"
          >
            <EventMap
              longitude={parseFloat(event.longitude)}
              latitude={parseFloat(event.latitude)}
              safetyScore={event.safetyScore && event.safetyScore.toString()}
            />
          </TabPane>
        </Tabs>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/EventDetails/EventTabs.jsx